import { useState, useEffect } from 'react';
import DedicatedNodeBody from './components/dedicatedNodeBody';

const DedicatedNode = () => {
  const [purchaseType, setPurchaseType] = useState<string>('');
  useEffect(() => {
    if (window.location.pathname.includes('full')) {
      setPurchaseType('dedicatedNode');
    } else {
      setPurchaseType('stakingNode');
    }
  }, []);
  return <DedicatedNodeBody purchaseType={purchaseType} />;
};

export default DedicatedNode;
